module.exports = __webpack_public_path__ + "static/media/single.82679394.svg";